import { render } from "./ProductCheckListOld.vue?vue&type=template&id=07375804"
import script from "./ProductCheckListOld.vue?vue&type=script&lang=js"
export * from "./ProductCheckListOld.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__